// Create and setup your form here

<template>
  <div>
    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-bind:language="language"
      v-bind:progressbar="true"
      v-bind:standalone="true"
    >
      <question
        v-for="(question, index) in questions"
        v-bind="question"
        v-bind:key="'m' + index"
        v-model="question.model"
      >
      </question>

      <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <template v-slot:complete>
        <div class="f-section-wrap">
          <div v-if="questions[0].model === 'author_publisher_yes'">
            <div>
              <p class="f-description">
                <span>
                  <strong>Congratulations on being published 😊!</strong><br />
                  We will review your submission to see if it is a fit for our
                  Launch. We will send out invites to our platform very soon.
                </span>
                <br /><br />
                <span>All the Best!!</span>
              </p>
            </div>
          </div>
          <div v-else>
            <span class="fh2"
              >We have added you to the Beta Program and look forward to the
              pre-launch.😉</span
            >
            <p class="f-description"><span>Have a great day!</span></p>
          </div>
        </div>
      </template>
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit">
          <!-- Leave empty to hide default submit button -->
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
// Import necessary components and classes
import { mapGetters } from "vuex";
import axios from "axios";
import FlowForm from "@/components/vueFlow/components/FlowForm.vue";
import Question from "@/components/vueFlow/components/Question.vue";
import LanguageModel from "@/components/vueFlow//models/LanguageModel";
import Notify from "@/mixins/Notify";
import firebase from "firebase";

export default {
  name: "Shelf",
  mixins: [Notify],
  components: {
    FlowForm,
    Question
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  data() {
    return {
      ip: "",
      formId: "survey_feedback_users",
      version: 10062022,
      loading: false,
      completed: false,
      language: new LanguageModel(),
      questions: [
        {
          type: "multiplechoice",
          id: "multiple_choice",
          tagline: "Welcome to HeartBeatFam",
          title:
            "Hi 👋, How would you feel if you could no longer use HeartBeatFam??",
          multiple: false,
          required: true,
          helpTextShow: false,
          options: [
            {
              label: "Very disapointed",
              value: "very_disapointed"
            },
            {
              label: "Somewhat disappointed",
              value: "somewhat_disapointed"
            },
            {
              label: "Not disappointed",
              value: "not_disapointed"
            }
          ],
          model: ""
        },
        {
          type: "Text",
          id: "question_2",
          tagline: "Verification",
          title:
            "What type of people do you think would most benefit from HeartBeatFam?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        },
        {
          type: "URL",
          id: "question_3",
          tagline: "Verification",
          title: "What is the main benefit you receive from HeartBeatFam?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        },
        {
          type: "Text",
          id: "question_3",
          tagline: "Verification",
          title: "How can we improve HeartBeatFam for you?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        }
      ]
    };
  },
  methods: {
    handleSubmitNewForm() {
      console.log("submitting new form");
    },
    //TODO- Put in mixin: saveToDb, OnComplete, onSendData, getData
    saveToDb(
      dataFromForm,
      formId = "default",
      version = 0,
      sessionCookieName = "default"
    ) {
      const formPayload = {
        response: { ...dataFromForm },
        user: {
          ip: this.ip,
          cookie: sessionCookieName,
          id: this.user.uid
        },
        form_id: formId,
        form: {
          version: version
        }
      };

      this.$store.dispatch("user/saveFormResponse", formPayload).then(() => {
        const formStatusPayload = {
          type: "form",
          id: formId,
          _created_at: new Date(),
          version: version
        };
        this.$store
          .dispatch("user/updateStatusForm", formStatusPayload)
          .then(() => {
            this.$emit("complete", dataFromForm);
          });

        const templateData = {
          test: "You did it"
        };

        this.sendFormOnBoardAuthorPublisherSubmitted(
          [this.user.uid],
          templateData
        ).then(() => {
          console.log("Sent Email");
        });
      });
    },
    /* eslint-disable-next-line no-unused-vars */
    onComplete(completed, questionList) {
      // This method is called whenever the "completed" status is changed.
      this.completed = completed;

      // Set `submitted` to true so the form knows not to allow back/forward
      // navigation anymore.
      this.$refs.flowform.submitted = true;

      this.onSendData();
    },

    onSendData() {
      const self = this;
      const data = this.getData();

      this.loading = true;
      this.saveToDb(data, this.formId, this.version, "signup_authorpublisher");

      setTimeout(() => {
        self.loading = false;
      }, 1500);
    },

    getData() {
      const data = {
        questions: [],
        answers: []
      };

      this.questions.forEach(question => {
        if (question.title) {
          let answer = question.model;
          if (Array.isArray(answer)) {
            answer = answer.join(", ");
          }

          data.questions.push(question.title);
          data.answers.push(answer);
        }
      });

      return data;
    }
  },
  mounted() {
    axios.get("https://api.ipify.org?format=json").then(res => {
      this.ip = res.data.ip;
    });
  }
};
</script>

<style lang="css" scoped>
@import "../_themes/theme-standard.css";
</style>
